import type { ReactElement } from "react";

/**
 * Marca de LigasDeportivas: el **balón de resultados (G/E/P)** — *logo 26*, el mismo
 * del favicon (`icon.svg`). Los paneles son los chips de resultado:
 * verde = ganó, rojo = perdió, gris = empató.
 *
 * Colores **literales** (no CSS-vars) a propósito: así se ve correcto también fuera
 * del árbol con tema (p. ej. `global-error`, que renderiza su propio `<html>`).
 */
export function BrandMark({ size = 64, className = "" }: { size?: number; className?: string }): ReactElement {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} role="img" aria-label="La Tablapp" className={className}>
      <circle cx="32" cy="32" r="30" fill="#1a2436" stroke="#eef1f7" strokeWidth="3.5" />
      <path d="M32 19.2 L44.8 28.8 L40 43.2 L24 43.2 L19.2 28.8 Z" fill="#2ee6a6" />
      <circle cx="32" cy="11" r="6" fill="#2ee6a6" />
      <circle cx="51" cy="26" r="6" fill="#ff5d73" />
      <circle cx="43" cy="51" r="6" fill="#9aa6bf" />
      <circle cx="21" cy="51" r="6" fill="#2ee6a6" />
      <circle cx="13" cy="26" r="6" fill="#ff5d73" />
    </svg>
  );
}
